import ButtonActionsOnUser from '../../../buttonActionsOnUser';
import BannerUserInfos from '../../../bannerUserInfos';
import { AdminUserPermissionsEnum } from '@/lib/enum';
import { SecuredComponent } from '@/components/hoc';
import { IUserData } from '@/lib/interface.ts';
import { Separator } from '@/components/ui';

interface TProps {
	user: IUserData;
}

const ProfileDetailUserDataSubAccountsItemViewDetailedHeader = ({ user }: TProps) => (
	<div className='flex flex-col'>
		<div className='flex items-center justify-between'>
			<BannerUserInfos
				enableClickToRedirectToProfile
				className='py-2 px-3 w-full'
				user={user}
				hideEmail />
			<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.PROFILE_DETAIL_ACTIONS]}>
				<ButtonActionsOnUser
					hideText
					className='mx-3 my-3'
					user={user} />
			</SecuredComponent>
		</div>
		<Separator />
	</div>
);

export default ProfileDetailUserDataSubAccountsItemViewDetailedHeader;
